import React from 'react';

interface School3DIconProps {
  size?: number;
  color?: string;
}

export const School3DIcon = ({ size = 48, color = '#10B981' }: School3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 40);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="16" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Building right side */}
      <path d="M48 28 L54 24 L54 52 L48 56 Z" fill={darkerColor} />
      {/* Building front */}
      <rect x="12" y="28" width="36" height="28" fill={color} />
      {/* Roof */}
      <polygon points="8,28 32,12 56,28 54,24 32,10 10,24" fill={lighterColor} />
      <polygon points="8,28 32,12 56,28" fill={color} />
      {/* Roof right side */}
      <path d="M56 28 L54 24 L32 10 L32 12 Z" fill={darkerColor} />
      {/* Door */}
      <rect x="27" y="42" width="10" height="14" rx="5" fill={darkerColor} />
      {/* Windows */}
      <rect x="16" y="33" width="7" height="6" rx="1" fill="white" opacity="0.4" />
      <rect x="41" y="33" width="7" height="6" rx="1" fill="white" opacity="0.4" />
      {/* Flag pole */}
      <line x1="32" y1="12" x2="32" y2="4" stroke={darkerColor} strokeWidth="1.5" />
      <rect x="32" y="4" width="6" height="4" rx="0.5" fill="#EF4444" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
